// "Song by Artist", or an empty string when nothing was requested
export const formatSongRequest = ({ songName, songArtist }) =>
  [songName, songArtist]
    .map((part) => (part || "").trim())
    .filter(Boolean)
    .join(" by ");

// wa.me link to the route's WhatsApp number, with the booking already typed in
export const buildWhatsappLink = (details, transport) => {
  const lines = [
    "Hi V2V, I have just made a booking.",
    "",
    `Reference: ${details.reference}`,
    `Name: ${details.fullName}`,
    `Cellphone: ${details.cellphone}`,
    `Route: ${details.transportRoute}`,
    `Pickup: ${details.pickupPoint}`,
    `Drop-off: ${details.dropoffLocation}`,
    `Travel date: ${details.travelDate}`,
    `Total price: ${details.totalPrice}`,
    `Deposit: ${details.deposit}`
  ];

  if (details.songRequest) {
    lines.push(`Song request: ${details.songRequest}`);
  }

  return `https://wa.me/${transport.contact.whatsapp}?text=${encodeURIComponent(lines.join("\n"))}`;
};
